import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';

import TextInput from 'common/text-input/text-input';
import WithSideBarAndNavBar from 'layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import { phoneNumberAddHypen } from 'constants/utils';
import useApi from 'hooks/useApi';
import { AxiosResponse } from 'axios';
import CryptoJS from 'crypto-js';
import useModalStore from 'zustands/useAlertConfirmStore';
import { useNavigate } from 'react-router-dom';
import useUserStore from 'zustands/useUserStore';
import useLogout from 'hooks/useLogout';
import useStoreStore from 'zustands/useStoreStore';
import moment from 'moment';

const Background = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-around;
`;
const LoginForm = styled.div`
  display: flex;
  width: 20%;
  min-width: 300px;
  flex-direction: column;
`;
const Section = styled.section`
  margin-bottom: 20px;
`;
const ImgArea = styled.div``;
const SubmitBtn = styled.button`
  margin-bottom: 20px;
  height: 5vh;
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 4px;
  background-color: #bc1a21;
`;
const JoinBtn = styled.button``;
const BackgroundImg = styled.img``;

const login = () => {
  const navigate = useNavigate();

  const { webApiNode } = useApi();
  const { setModalState } = useModalStore();
  const { setUserInfo, setManagerInfo, setISP } = useUserStore();
  const { setStoreInfo } = useStoreStore();

  const logoutFn = useLogout();

  const [id, setId] = useState<string>('');
  const [pwd, setPwd] = useState<string>('');
  const [inputError, setInputError] = useState({
    name: '',
    message: '',
  });
  const [isPwdVisible, setIsPwdVisible] = useState<boolean>(false);
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === 'loginID') {
      setId(phoneNumberAddHypen(value));
      if (value.length === 13) {
        pwdInputRef?.current?.focus();
      }
    }
    if (name === 'loginPWD') setPwd(value);
  };

  const handleEnterKeyOnPwdInput = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      loginFn();
    }
  };

  const loginFn = async () => {
    try {
      const ID = id.split('-').join('');
      if (ID.length !== 11) {
        idInputRef?.current?.focus();
        setInputError({ name: 'loginID', message: '올바른 휴대폰번호 11자리를 입력해 주세요' });
        return;
      }
      if (pwd.length === 0) {
        pwdInputRef?.current?.focus();
        setInputError({ name: 'loginPWD', message: '비밀번호를 입력해 주세요.' });
        return;
      }
      const ENCODING_KEY: string = process.env.REACT_APP_ENCODING_KEY ?? '';

      console.log('ENCODING_KEY', ENCODING_KEY);

      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/webmanagerLogin2`, {
        MobileNo: CryptoJS.AES.encrypt(ID, ENCODING_KEY).toString(),
        PASSWORD: CryptoJS.AES.encrypt(pwd, ENCODING_KEY).toString(),
      });
      console.log('auth/webmanagerLogin2 data', data);
      if (data.resultCode === 0) {
        setUserInfo({
          userId: '',
          userSeq: Number(data.MEMBER_SEQ),
          userToken: data.resultData,
          userType: data.resultType,
        });
        setISP(pwd === 'wesop12345');
        navigate(`/business-establishment-choice`);
      } else {
        return setModalState({
          isModalShow: true,
          title: '로그인',
          desc: data.resultMsg,
        });
      }
    } catch (err) {
    } finally {
    }
  };

  const openJoinPage = () => {
    window.open('https://www.shop-sol.com/join', '_self');
  };

  const idInputRef = useRef<HTMLInputElement>(null);
  idInputRef;
  const pwdInputRef = useRef<HTMLInputElement>(null);
  pwdInputRef;

  React.useEffect(() => {
    if (moment().isBefore(moment('2024-05-02'))) {
      setModalState({
        isModalShow: true,
        image: {
          url: 'https://wesop.s3.ap-northeast-2.amazonaws.com/shopsol/popup/workersDay_240430.jpg',
          width: 290,
          height: 409,
        },
      });
    }
    logoutFn();
    setStoreInfo({ storeSeq: '', storeName: '', storeSeqNumber: 0 });
    setManagerInfo({
      empSeq: 0,
      payShow: false,
      storePayShow: false,
      otherPayShow: false,
      calendarEdit: false,
      recievePush: false,
    });
  }, []);

  return (
    <WithSideBarAndNavBar>
      <Background>
        <LoginForm>
          <Section>
            <TextInput
              ref={idInputRef}
              value={id}
              inputData={handleInput}
              label="휴대폰번호(ID)"
              placeholder="휴대폰번호 입력"
              inputName="loginID"
              errorMessage={inputError.name === 'loginID' ? inputError.message : ''}
              maxLength={13}
            />
          </Section>
          <Section style={{ position: 'relative' }}>
            <TextInput
              ref={pwdInputRef}
              value={pwd}
              onkeydown={handleEnterKeyOnPwdInput}
              inputData={handleInput}
              label="비밀번호"
              placeholder="비밀번호 입력"
              inputName="loginPWD"
              errorMessage={inputError.name === 'loginPWD' ? inputError.message : ''}
              inputType={isPwdVisible ? 'text' : 'password'}
              /*  바말번호 표시 버튼 추가    */
            />
            <div
              style={{
                position: 'absolute',
                right: 12,
                top: 40,
                display: 'flex',
                alignItems: 'center',
              }}>
              <img
                src={isPwdVisible ? require('assets/icons/eye-on.png') : require('assets/icons/eye-off.png')}
                alt=""
                style={{ cursor: 'pointer' }}
                onClick={() => setIsPwdVisible(!isPwdVisible)}
              />
            </div>
          </Section>
          <SubmitBtn onClick={loginFn}>로그인</SubmitBtn>
          <JoinBtn onClick={openJoinPage}>회원가입</JoinBtn>
        </LoginForm>
        <ImgArea>
          <BackgroundImg src={require('assets/images/myshop.png')} />
        </ImgArea>
      </Background>
    </WithSideBarAndNavBar>
  );
};

export default login;
